export default "__VITE_ASSET___app/immutable/assets/logotype-docs.B3ZoZtg5.svg__"